import { render } from "./ChangeAccBankView.vue?vue&type=template&id=252c2b2e"
import script from "./ChangeAccBankView.vue?vue&type=script&lang=js"
export * from "./ChangeAccBankView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__